import { Link } from "react-router-dom";

/**
 * Visible breadcrumb trail for public pages.
 * @param {{ name: string, path: string, current?: boolean }[]} items
 */
export default function SiteBreadcrumbs({ items, className = "" }) {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <nav className={`jw-breadcrumbs${className ? ` ${className}` : ""}`} aria-label="Breadcrumb">
      <ol className="jw-breadcrumb-list">
        {items.map((item, index) => (
          <li key={`${item.path}-${index}`} className="jw-breadcrumb-item">
            {index > 0 ? (
              <span className="jw-breadcrumb-sep" aria-hidden="true">
                /
              </span>
            ) : null}
            {item.current ? (
              <span aria-current="page">{item.name}</span>
            ) : (
              <Link to={item.path}>{item.name}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
